import logger from '@/utils/client-logger';
import { ReportingCenter } from './reportingCenter';
import type { SgtmPixelConfig, TrackingConfig } from './trackingConfig';

declare global {
  interface Window {
    __TRACKING_CONFIG__?: TrackingConfig;
    __SGTM_PIXEL_CONFIG__?: SgtmPixelConfig | null;
    __TRACKING_DEBUG__?: TrackingDebugAPI;
  }
}

interface TrackingDebugAPI {
  getConfig: () => TrackingConfig | undefined;
  getSgtmPixelConfig: () => SgtmPixelConfig | null | undefined;
  getProviders: () => string[];
  getEnabledProviders: () => string[];
}

/**
 * 初始化调试工具到 window
 * 仅在 dev/local/test 环境生效
 */
export function initTrackingDebug(
  config?: TrackingConfig,
  sgtmPixelConfig?: SgtmPixelConfig | null,
): void {
  if (typeof window === 'undefined') return;

  window.__TRACKING_CONFIG__ = config;
  window.__SGTM_PIXEL_CONFIG__ = sgtmPixelConfig;

  window.__TRACKING_DEBUG__ = {
    getConfig: () => window.__TRACKING_CONFIG__,
    getSgtmPixelConfig: () => window.__SGTM_PIXEL_CONFIG__,
    getProviders: () => ReportingCenter.getInstance().listProviders(),
    getEnabledProviders: () => {
      const center = ReportingCenter.getInstance();
      return center.listProviders().filter((type) => {
        const provider = center.getProvider(type as any);
        return provider?.isEnabled;
      });
    },
  };

  logger.log('[TrackingDebug] 调试工具已初始化，可用命令:');
  logger.log('  window.__TRACKING_DEBUG__.getConfig()           — 查看 BFF tracking_config');
  logger.log('  window.__TRACKING_DEBUG__.getSgtmPixelConfig()  — 查看 SGTM 像素开关配置');
  logger.log('  window.__SGTM_PIXEL_CONFIG__                    — 直接查看 SGTM 像素开关');
  logger.log('  window.__TRACKING_DEBUG__.getProviders()        — 查看所有已注册 Provider');
  logger.log('  window.__TRACKING_DEBUG__.getEnabledProviders() — 查看已启用 Provider');
}
